import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './StaticPages.css';

const FaqPage = () => {
    const { t } = useTranslation();
    const [openItem, setOpenItem] = useState(null);

    const faqData = [
        { qKey: 'faq_q1', aKey: 'faq_a1' },
        { qKey: 'faq_q2', aKey: 'faq_a2' },
        { qKey: 'faq_q3', aKey: 'faq_a3' },
        { qKey: 'faq_q4', aKey: 'faq_a4' },
		{ qKey: 'faq_q5', aKey: 'faq_a5' },
		 { qKey: 'faq_q6', aKey: 'faq_a6' },
        { qKey: 'faq_q7', aKey: 'faq_a7' },
        { qKey: 'faq_q8', aKey: 'faq_a8' },
        { qKey: 'faq_q9', aKey: 'faq_a9' }
    ];

    const toggleItem = (index) => {
        setOpenItem(openItem === index ? null : index);
    };

    return (
        <div className="page-container static-page">
            <div className="static-header">
                <h1>{t('faq_title', 'Sıkça Sorulan Sorular')}</h1>
                <p>{t('faq_subtitle', 'Aklınızdaki soruların cevapları burada.')}</p>
            </div>
            <div className="faq-container">
                {faqData.map((item, index) => (
                    <div className="faq-item" key={index}>
                        <div className="faq-question" onClick={() => toggleItem(index)}>
                            <span>{t(item.qKey)}</span>
                            <i className={`fas fa-chevron-down faq-icon ${openItem === index ? 'open' : ''}`}></i>
                        </div>
                        <div className={`faq-answer ${openItem === index ? 'open' : ''}`}>
                            <p>{t(item.aKey)}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
export default FaqPage;